/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
      apiKey: "AIzaSyBjrMlIjesHWZUOZXe1W7gGZFSdjL9tAfo",
      authDomain: "tiptunes-app.firebaseapp.com",
      projectId: "tiptunes-app",
      storageBucket: "tiptunes-app.appspot.com",
      messagingSenderId: "352122804136",
      appId: "1:352122804136:web:4661a4807f0af56d1eef9d",
      measurementId: "G-DBZ0NPKY9S"
  }
};